import { FeedbackResponseForm, Loading, Section } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import styled from "styled-components";
import { feedbackPreviewService } from "../shared/api/feedbackPreviewService";

const Container = styled(Section).attrs({ color: "content" })`
	padding: ${({ theme }) => theme.spacing(6)} ${({ theme }) => theme.spacing(2)};
	max-width: 800px;
	margin: 0 auto;
`;

const DisabledSubmitWrapper = styled.div`
	form button[type="submit"] {
		opacity: 0.5;
		pointer-events: none;
		cursor: not-allowed;
	}
`;

const FeedbackPreviewContent: FC<{ feedbackId: string }> = ({ feedbackId }) => {
	const { t } = useTranslation();
	const { data: feedback, isLoading } = useQuery({
		queryKey: feedbackPreviewService.previewKey(feedbackId),
		queryFn: () => feedbackPreviewService.getFeedbackPreview(feedbackId).then((r) => r.data.data),
	});

	if (isLoading) {
		return <Loading />;
	}

	if (!feedback) {
		return null;
	}

	return (
		<Container>
			<DisabledSubmitWrapper>
				<FeedbackResponseForm feedback={feedback} onSubmit={async () => false} submitTitle={t("Submit")} />
			</DisabledSubmitWrapper>
		</Container>
	);
};

export const FeedbackPreviewPage: FC = () => {
	const { feedbackId = "" } = useParams<{ feedbackId: string }>();

	return <FeedbackPreviewContent feedbackId={feedbackId} />;
};
